/**
 * The one sentence that follows a move made while a limit is reached.
 *
 * Kept beside the feature rather than inline in the toast so the board's line
 * and the move's confirmation cannot drift into saying different things about
 * the same condition, and so a test asserts the product's words rather than a
 * copy of them (spec 101 FR-008).
 */
export const NO_RUN_UNTIL_LIMIT =
  'No run will start until the spend limit resets or is raised.';
